<template>
    <div id="app" v-cloak>
  <transition name="slide"><router-view v-if="isRouterAlive" /></transition>
    </div>
</template>
<script>
    export default {
        name: "APP",
        provide() {
    return {
      reload: this.reload
    };
  },
           data() {
    return { 
      input: "",
       isRouterAlive: true
    };
  },
  created() {
    //  document.title = process.env.NODE_ENV === 'development' ? this.$route.meta.title + '-平台端-测试' : this.$route.meta.title + '-平台端'
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
    }
</script>
<style lang="scss" scoped>
    /*每个页面公共css */
    @import url("assets/styles/iconfont.css");
    @import "assets/styles/main.scss";
</style>
